<script setup>
import { SelectRoot, useForwardPropsEmits } from 'reka-ui';

// Wrapper quanh SelectRoot của reka-ui — forward toàn bộ props/emits (gồm v-model, by...).
const props = defineProps({
    modelValue: { type: null, default: undefined },
    defaultValue: { type: null, default: undefined },
    open: { type: Boolean, default: undefined },
    by: { type: [String, Function], default: undefined },
    disabled: { type: Boolean, default: undefined },
});

const emits = defineEmits(['update:modelValue', 'update:open']);
const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
    <SelectRoot v-bind="forwarded">
        <slot />
    </SelectRoot>
</template>
